import { render, staticRenderFns } from "./slices.vue?vue&type=template&id=4b7a773d&scoped=true&"
import script from "./slices.vue?vue&type=script&lang=js&"
export * from "./slices.vue?vue&type=script&lang=js&"
import style0 from "./slices.vue?vue&type=style&index=0&id=4b7a773d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a773d",
  null
  
)

export default component.exports